<template>
   <vx-card class="lesson track-lesson-clicked mt-2 p-2 shadow-md border-solid border-2 border-transparent select-none" :cardBackground="cardBackground" :class="classes" @click.stop="emitClick">
      <template v-slot:title>
        <div class="flex items-center content-center">
            <img class="w-16" :src="img">
          <div class="ml-4 w-9/10">
            <div class="text-left font-black text-xl">

              <div class="flex items-center flex-wrap">
                <span class="flex items-center mr-2" :class="titleClasses">{{sessionTitle}}{{title}}<feather-icon class="text-success ml-1 w-6" v-if="completed" icon="CheckIcon" />
                </span>

                <span v-if="open">
                  <vs-chip size="small" color="success" class="m-0">
                    new
                  </vs-chip>
                </span>
                <span v-if="pending">
                    <vs-chip color="grey" size="small" class="m-0 flex items-center">
                      <feather-icon icon="LockIcon" class="mr-1" svgClasses="h-4 w-4"/>
                      {{pendingText}}
                  </vs-chip>
                </span>
              </div>

              </div>
            <div class="text-left">{{subtitle}}</div>
          </div>
        </div>
      </template>
    </vx-card>

</template>

<script>

import _ from 'lodash'

import { LESSONS } from './lessons'

export default {
  props: ['lesson'],
  data () {
    return {

    }
  },
  computed: {
    sessionTitle () {
      if (this.lessonData.showSessionOrder) {
        return `SESSION ${this.order}: `
      }
    },
    pendingText () {
      if (this.$store.getters.hasOpenLessons) {
        if (this.$store.getters.openLessonIndex < 0) {
          return 'complete the previous one'
        } else {
          return  `complete SESSION ${this.$store.getters.openLessonIndex}`
        }
      } else {
        return 'tomorrow'
      }
    },
    lessonData () {
      return _.find(LESSONS, (lesson) => lesson.name === this.lesson.name)
    },
    title () {
      return this.lessonData.title
    },
    subtitle () {
      return this.lessonData.subtitle
    },
    pending () {
      return this.lesson.status === 'pending'
    },
    open () {
      return this.lesson.status === 'open'
    },
    completed () {
      return this.lesson.status === 'completed'
    },
    cardBackground () {
      if (this.pending) {
        return 'black'
      } else if (this.open) {
        return 'black'
      }
    },
    order () {
      return this.lesson.order
    },
    titleClasses () {
      if (this.completed) {
        return ''
      }
    },
    classes () {
      if (this.pending) {
        return 'cursor-not-allowed'
      }
      return this.open ? 'text-white hover:border-white cursor-pointer hover:shadow-lg' : `text-black hover:border-black cursor-pointer hover:shadow-lg track-${this.lesson.name}`
    },
    img () {
      return this.enhancedLesson.img
    },
    enhancedLesson () {
      return {id: this.lesson.id, ...this.lesson, ...this.lessonData}
    }
  },
  methods: {
    emitClick () {
      if (!this.pending) {
        this.$emit('showPopup', this.enhancedLesson)
      }
    }
  },
  mounted () {

  }
}

</script>


<style scoped lang="scss">
</style>
